'use client'

import React, { useEffect, useState } from 'react'

const DEFAULT_BYPASS_CHECK_URL = '/api/maintenance-bypass'

type MaintenanceBypassIndicatorProps = {
    bypassCheckUrl?: string
}

export const MaintenanceBypassIndicator = ({
    bypassCheckUrl = DEFAULT_BYPASS_CHECK_URL,
}: MaintenanceBypassIndicatorProps) => {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const check = async () => {
            try {
                const response = await fetch(bypassCheckUrl, { credentials: 'same-origin' })
                if (!response.ok) {
                    return
                }
                const data = (await response.json()) as { isBypassed?: boolean }
                if (data.isBypassed === true) {
                    setVisible(true)
                }
            } catch {
                // Silently fail
            }
        }
        check()
    }, [bypassCheckUrl])

    if (!visible) return null

    return (
        <div className="fixed bottom-4 right-4 z-50 bg-error-600 text-white px-4 py-2 rounded-lg shadow-lg text-sm font-medium flex items-center gap-2">
            <span className="w-2 h-2 bg-white rounded-full animate-pulse" />
            Onderhoudsmodus actief — bypass via IP
        </div>
    )
}
